import { ExitVariant, LeadMagnetStage } from '@/types/lead-magnet';

export const LEAD_MAGNET_PATH_PREFIX = '/quiz';

export const getLeadMagnetPath = (slug: string) => `${LEAD_MAGNET_PATH_PREFIX}/${slug}`;

export const BACK_FROM_FIRST_QUESTION: 'intro' | 'stay' | 'exit' = 'intro';

export const LEAD_MAGNET_HOME_URL = '/';

// Must match the actual stage backgrounds used for Safari theme-color.
export const LEAD_MAGNET_THEME_COLORS: Record<LeadMagnetStage, string> = {
	intro: '#0d0d0d',
	question: '#0d0d0d',
	lead: '#000000',
	breakdown: '#000000'
};

export const LEAD_MAGNET_EXIT_VARIANTS = ['intro', 'inProgress', 'lastQuestion', 'result'] as const;

export const EXIT_MODAL_LABEL_DEFAULTS: Record<
	ExitVariant,
	{ leaveLabel: string; continueLabel: string }
> = {
	intro: { leaveLabel: 'Leave anyway', continueLabel: 'Continue' },
	inProgress: { leaveLabel: 'Leave anyway', continueLabel: 'Continue' },
	lastQuestion: { leaveLabel: 'Leave anyway', continueLabel: 'Continue' },
	result: { leaveLabel: 'Back to the site', continueLabel: 'Run the test again' }
};

export const LEAD_MAGNET_STORAGE_PREFIX = 'qream:lead-magnet';

export const LEAD_MAGNET_SNAPSHOT_VERSION = 1;

export const LEAD_MAGNET_SNAPSHOT_TTL_MS = 2 * 60 * 60 * 1000;

export const LEAD_MAGNET_DEFAULTS = {
	exitLabel: 'Exit',
	exitUrl: '/',
	progressLabelFormat: '{current}/{total}',
	introCtaLabel: 'Start',
	expandLabel: 'Unpack this',
	collapseLabel: 'Collapse',
	recommendedActionLabel: 'RECOMMENDED ACTION',
	successCtaLabel: 'Got it',
	backLabel: 'Back'
} as const;
